import { Row } from './Row';

export const TrackedUrlEvents = (props) => {
    return props.events.map(({ eventName, timestamp, urls }, rowId) => {
        return (
            <Row key={rowId}>
                <div>{timestamp}</div>
                <div>{eventName}</div>
                <div>
                    <ul>
                        {urls.map((url, liId) => <li key={liId}>{url}</li>)}
                    </ul>
                </div>
            </Row>
        );
    });
};